import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../shared/auth/auth.service';
import { environment } from 'environments/environment';

/**
 * SEG-2671 — Componente atrelado à wildcard route (**).
 *
 * Ao ser instanciado (rota inválida detectada):
 * 1. Chama GET /public/routes/invalid?path=...&authenticated=...
 * 2. A API loga a tentativa e retorna 302 (visível no Network/Grafana)
 * 3. No complete/error do subscribe, faz redirect client-side para /home ou /pages/login
 *
 * Não fica em loop porque /home/ e /pages/login são rotas válidas que
 * fazem match no Router antes da wildcard.
 */
@Component({ template: '', standalone: true })
export class InvalidRouteComponent implements OnInit {

  constructor(
    private router: Router,
    private authService: AuthService,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    const path = this.router.url;
    const authenticated = this.authService.isAuthenticated();

    this.http.get(
      `${environment.urlApi}public/routes/invalid?path=${encodeURIComponent(path)}&authenticated=${authenticated}`,
      { observe: 'response' }
    ).subscribe({
      complete: () => this.redirect(authenticated),
      error: () => this.redirect(authenticated)
    });
  }

  private redirect(authenticated: boolean): void {
    this.router.navigate(authenticated ? ['/home/'] : ['/pages/login']);
  }
}
